import { Storage } from '@ionic/storage';
import FetchAdapter from '@pollyjs/adapter-fetch';
import { Polly, Request, Response } from '@pollyjs/core';
import LocalStoragePersister from '@pollyjs/persister-local-storage';
import { findIndex, findWhere } from 'underscore';
import { GenerateCode, Get, Set } from './MockHelper';
import moment from 'moment'
import jwt from 'jsonwebtoken'
import uuid4 from "uuid4"


Polly.register(FetchAdapter);
Polly.register(LocalStoragePersister);



const polly = new Polly('Mock API', {
    adapters: ['fetch'],
    persister: 'local-storage'
});
const { server } = polly;

const IonicStorage = new Storage({
    name: 'mock-server'
})

const UserMocks = async () => {
    const storage = await IonicStorage.create()
    server.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`).intercept(async (req: Request, res: Response) => {
        const token = await storage.get('token')
        const auth_codes = await Get('auth_codes')
        const auth_code = findWhere(auth_codes, {
            token: token
        })
        if (auth_code && auth_code.is_claimed) {
            let role = 'guest'
            const [users, app_users] = await Promise.all([
                Get('users'),
                Get('app_users')
            ])
            const user = findWhere(users, {
                email: auth_code.email
            })
            const app_user = findWhere(app_users, {
                email: auth_code.email,
                app_id: auth_code.app_id
            })

            if (app_user) {
                role = app_user.role
            }
            if (user) {
                res.status(200).json({ ...user, role })
            } else {
                res.status(401).json({ detail: 'Authentication failed' })
            }
        } else {
            res.status(401).json({ detail: 'Authentication failed' })
        }
    })
}

const AuthMocks = async () => {
    const storage = await IonicStorage.create()
    server.post(`${process.env.REACT_APP_API_BASE_URL}/auth/claim`).intercept(async (req: Request, res: Response) => {
        const { code } = JSON.parse(req.body as string)
        try {
            const auth_codes = await Get('auth_codes')
            const index = findIndex(auth_codes, item => item.code === code)
            if (index > -1) {
                const token = GenerateCode(120)
                auth_codes[index].is_claimed = true
                auth_codes[index].token = token
                await Set('auth_codes', auth_codes)
                await storage.set(`token`, token)
                res.status(200).json({
                    message: `Authentication success`,
                    data: { token }
                })
            } else {
                res.status(401).json({ detail: `Authentication failed` })
            }
        } catch (e) {
            res.status(500).json({ detail: `Something went wrong` })
        }
    })
}

const TableauMocks = async () => {
    const CONNECTED_APP_CLIENT_ID = `4d1c6785-6081-470e-b3eb-5ac370d5d768`
    const CONNECTED_APP_SECRET_ID = `2870d88c-d1f7-4226-aa4d-eeb55f465ba2`
    const CONNECTED_APP_SECRET_VALUE = `t4XvkWvTrXorarNxjM8EMPy6lfA5zaU2EA6Xk0LMIFQ=`

    server.get(`${process.env.REACT_APP_API_BASE_URL}/tableau/get-token`).intercept(async (req: Request, res: Response) => {
        try {
            const expiration_date = moment(new Date()).add(5, 'minutes').toDate().getTime()
            const payload = {
                "iss": CONNECTED_APP_CLIENT_ID,
                "exp": Math.floor(expiration_date / 1000),
                "jti": uuid4(),
                "aud": "tableau",
                "sub": "developer@analyticsmart.com",
                "scp": [
                    "tableau:views:embed"
                ]
            }
            const header = {
                "alg": "HS256",
                "typ": "JWT",
                "kid": CONNECTED_APP_SECRET_ID,
                "iss": CONNECTED_APP_CLIENT_ID
            }
            const token = jwt.sign(payload, CONNECTED_APP_SECRET_VALUE, {
                header: header
            })
            res.status(200).json({
                message: `Getting token success`,
                data: { token }
            })
        } catch (e) {
            console.log(e, 'error')
            res.status(500).json({ detail: 'Failed to create token' })
        }
    })

    server.get(`${process.env.REACT_APP_API_BASE_URL}/tableau/get-location/:category/:sap_id`).intercept(async (req: Request, res: Response) => {
        try {
            const sap_locations = await Get('sap_locations')
            const location = findWhere(sap_locations, {
                sap_id: parseInt(req.params.sap_id),
                category: req.params.category
            })
            if (location) {
                res.status(200).json({
                    message: `Getting location success`,
                    data: location
                })
            } else {
                const fallback_location = findWhere(sap_locations, {
                    category: req.params.category
                })
                if(fallback_location){
                    res.status(200).json({
                        message: `Getting location success`,
                        data: fallback_location
                    })
                }else{
                    res.status(500).json({ detail: 'Failed to get location' })
                }
            }
        } catch (e) {
            res.status(500).json({ detail: 'Failed to get location' })
        }
    })
}

export const ServerMock = async () => {
    await Promise.all([
        UserMocks(),
        AuthMocks(),
        TableauMocks()
    ])
}